import React from 'react';
import { cx } from './classNames';
import './ui.css';

export interface StatItem {
  label: React.ReactNode;
  value: React.ReactNode;
  hint?: React.ReactNode;
}

export interface StatStripProps extends React.HTMLAttributes<HTMLDivElement> {
  items: StatItem[];
  /** 上に破線を引く（テーブル下の集計行など） */
  dashed?: boolean;
  /** 右端に寄せるボタン群 */
  actions?: React.ReactNode;
}

export function StatStrip({ items, dashed = false, actions, className, ...rest }: StatStripProps) {
  return (
    <div className={cx('ui-stat', dashed && 'ui-stat--dashed', className)} {...rest}>
      <ul className="ui-stat__list">
        {items.map((item, i) => (
          <li className="ui-stat__item" key={i}>
            <span className="ui-stat__label">{item.label}</span>
            <span className="ui-stat__value">{item.value}</span>
            {item.hint != null && <span className="ui-stat__hint">{item.hint}</span>}
          </li>
        ))}
      </ul>
      {actions != null && <div className="ui-stat__actions">{actions}</div>}
    </div>
  );
}
